import React from 'react';

import TagDiscounts from '../TagDiscounts/TagDiscounts';

const ModuleTagsDiscounts = ({
  tagsDiscounts,
  home,
  primaryColor,
  uiVariantBannerPromo,
}) => {
  return (
    <TagDiscounts
      tags={tagsDiscounts}
      discountsTitle={home.discountsTitle}
      primaryColor={primaryColor}
      uiVariantBannerPromo={uiVariantBannerPromo}
    />
  );
};

export default ModuleTagsDiscounts;
